import React, { Fragment, useReducer } from 'react'
import { Container, Typography } from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'

import { Modal } from '../../components/Modal/Modal'

import { Modal as EOSModal } from '../../components/_EOS/Modal'

import { SnackBar } from '../../components/SnackBar/Snackbar'

import { useFetchDataGrid } from '../../hooks/useFetchDatagrid'

import {
  ViewAlmacen,
  CreateAlmacen,
  SearchAlmacen,
  almacenReducer,
  reducerInitialState,
  WarehouseList
} from '../../components/Almacen'

import {
  Warehouse,
  WarehouseGrid,
  ICreateWarehouse
} from '../../interfaces/Warehouse/Warehouse'

import { ConfirmAction } from '../../components/ConfirmAction'
import { useHistory } from 'react-router-dom'
import { searchInitialState } from '../../components/Almacen/warehouseConfig'
import { Loading, Pagination } from '../../components/UI'

import { useStyles } from './styles'
import { apiCall, ApiConfig } from '../../config/api'
import { useConfirmsAction } from '../../hooks/useConfirmAction'
import { pathZone } from '../../const/locationPaths'
import { useWarehouses } from '../../hooks'

interface AlmacenPageProps {}

interface Filter {
  key: string
  value: string
}

export const AlmacenPage: React.FC<AlmacenPageProps> = () => {
  const { isLoadingConfirm, setLoadingConfirm } = useConfirmsAction()
  const classes = useStyles()
  const [state, dispatch] = useReducer(almacenReducer, reducerInitialState)

  const history = useHistory()

  const {
    openDelete,
    openRedireccion,
    page,
    rowsPerPage,
    totalItems,
    editableItem,
    openSnackbar,
    messageColor,
    messageStatus,
    rows,
    busqueda,
    filters,
    idForDelete,
    openView,
    isLoading
    // gridError
  } = state

  const handleBusqueda = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: 'SET_BUSQUEDA',
      payload: { ...busqueda, [event.target.name]: event.target.value }
    })
  }

  useFetchDataGrid<Warehouse, WarehouseGrid>(
    ApiConfig.WareHouseApi,
    page,
    rowsPerPage,
    filters,
    dispatch
  )

  const { getWarehouses } = useWarehouses()

  const handleSubmit = async (values: any) => {
    apiCall('POST', ApiConfig.WareHouseApi, values)
      .then(() => {
        MostrarMensajeConfirmacion('Almacén creado correctamente.', 'success')
        hadleOpenRedireccion()
        fetchFilteredData()
      })
      .catch(({ data: { message } }) => {
        const error = message === undefined ? 'Error al crear Almacén' : message
        MostrarMensajeConfirmacion(error, 'error')
      })
      .finally(getWarehouses)
  }

  const handleSubmitEdit = async (values: any | ICreateWarehouse) => {
    apiCall('PUT', `${ApiConfig.WareHouseApi}/${values.id}`, values)
      .then(() => {
        MostrarMensajeConfirmacion(
          'Almacen actualizado correctamente.',
          'success'
        )
        fetchFilteredData()
      })
      .catch(({ data: { message } }) => {
        const error = message === undefined ? 'Error al crear Almacén' : message
        MostrarMensajeConfirmacion(error, 'error')
      })
      .finally(getWarehouses)
  }

  const MostrarMensajeConfirmacion = (mensaje: string, tipoMensaje: any) => {
    dispatch({ type: 'SET_MESSAGE_STATUS', payload: mensaje })
    dispatch({ type: 'SET_MESSAGE_COLOR', payload: tipoMensaje })
    dispatch({ type: 'SWITCH_SNACKBAR', payload: true })
    dispatch({ type: 'SWITCH_MODAL', payload: false })
  }

  const fetchFilteredData = () => {
    dispatch({
      type: 'SET_FILTERS',
      payload: busqueda
        ? Object.keys(busqueda)
            .filter((key) => busqueda[key] !== '')
            .map<Filter>((key) => ({
              key: key,
              value: busqueda[key].toString()
            }))
        : []
    })
  }

  const resetearBusqueda = () => {
    dispatch({
      type: 'SET_BUSQUEDA',
      payload: searchInitialState
    })
  }

  const handleSnackbar = (isOpen: boolean) => {
    dispatch({ type: 'SWITCH_SNACKBAR', payload: isOpen })
  }

  const handleOpen = () => {
    dispatch({ type: 'SWITCH_EDITABLE_ITEM', payload: undefined })
    dispatch({ type: 'SWITCH_MODAL', payload: true })
  }

  const handleClose = () => {
    dispatch({ type: 'SWITCH_MODAL', payload: false })
  }

  const handlePageChange = (updatePage: number) => {
    dispatch({ type: 'CHANGE_PAGE', payload: updatePage - 1 })
  }

  const handlePageSizeChange = (event: SelectChangeEvent<number>) => {
    dispatch({ type: 'CHANGE_PAGE', payload: 0 })
    dispatch({
      type: 'CHANGE_PAGE_SIZE',
      payload: Number(event.target.value)
    })
  }

  const handleDoubleClick = (param: Warehouse) => {
    dispatch({
      type: 'SWITCH_EDITABLE_ITEM',
      payload: {
        id: parseInt(param.id.toString()),
        warehouseCode: param.warehouseCode,
        postalCode: param.postalCode,
        warehouseDescription: param.warehouseDescription,
        zones: param.zones,
        zoneId: param.zones.find((zone) => zone.default)?.zoneId!,
        warehouseAddress: param.warehouseAddress,
        warehouseName: param.warehouseName,
        warehouseSchedule: param.warehouseSchedule,
        active: param.active
      }
    })
    dispatch({ type: 'SWITCH_MODAL', payload: true })
  }

  const handleSubmitDelete = async () => {
    setLoadingConfirm(true)
    apiCall('DELETE', `${ApiConfig.WareHouseApi}/${idForDelete}`)
      .then((response) => {
        if (response.status !== 204) {
          throw new Error('Hubo un problema al eliminar el Almacén.')
        }
      })
      .then(() => {
        MostrarMensajeConfirmacion(
          'Almacén eliminado correctamente.',
          'success'
        )
        fetchFilteredData()
        setIdForDelete(undefined)
      })
      .catch(({ data: { error } }) => {
        MostrarMensajeConfirmacion(error.toString(), 'error')
        setIdForDelete(undefined)
      })
      .then(() => {
        handleCloseDelete()
        setLoadingConfirm(false)
      })
      .finally(getWarehouses)
  }

  // MODAL DELETE
  const handleOpenDelete = (idForDelete: number | undefined) => {
    dispatch({ type: 'SWITCH_MODAL_DELETE', payload: true })
    dispatch({ type: 'SET_ID_FOR_DELETE', payload: idForDelete })
  }

  const handleCloseDelete = () => {
    dispatch({ type: 'SWITCH_MODAL_DELETE', payload: false })
  }

  const setIdForDelete = (idForDelete: number | undefined) => {
    dispatch({ type: 'SET_ID_FOR_DELETE', payload: idForDelete })
  }

  // MODAL VIEW
  const hadleOpenView = (idForView: number | undefined) => {
    dispatch({ type: 'SET_ID_FOR_DELETE', payload: idForView })
    dispatch({ type: 'SWITCH_MODAL_VIEW', payload: true })
  }
  const handleCloseView = () => {
    dispatch({ type: 'SET_ID_FOR_DELETE', payload: undefined })
    dispatch({ type: 'SWITCH_MODAL_VIEW', payload: false })
  }

  // MODAL REDIRECCIÓN
  const hadleOpenRedireccion = () => {
    dispatch({ type: 'SWITCH_MODAL_REDIRECCION', payload: true })
  }

  const handleCloseRedireccion = () => {
    dispatch({ type: 'SWITCH_MODAL_REDIRECCION', payload: false })
  }

  const handleRedirectZoneCRUD = () => {
    history.push(`/wms/${pathZone}`)
  }

  return (
    <Fragment>
      <Container maxWidth='xl'>
        <Typography variant='h4' component='h2' gutterBottom>
          Administrador de Almacenes
        </Typography>
      </Container>
      <SearchAlmacen
        handleBusqueda={handleBusqueda}
        busqueda={busqueda}
        handleResetBusqueda={resetearBusqueda}
        handleCrearAlmacen={handleOpen}
        handleFetchFilteredData={fetchFilteredData}
      />

      <Modal
        funcClose={handleClose}
        isOpen={state.open}
        size='XS'
        title={editableItem ? 'Editar Almacén' : 'Crear Almacén'}
      >
        <CreateAlmacen
          warehouseEditable={editableItem}
          handleSubmit={editableItem ? handleSubmitEdit : handleSubmit}
        />
      </Modal>

      <Modal
        funcClose={handleCloseView}
        isOpen={openView}
        backdropClick={false}
        size='XS'
      >
        <ViewAlmacen
          elemento={rows.filter((item) => item.id === idForDelete)[0]}
        />
      </Modal>

      <EOSModal onClose={handleCloseDelete} open={openDelete} maxWidth='sm'>
        <ConfirmAction
          handleCloseModal={handleCloseDelete}
          handleSubmitAction={handleSubmitDelete}
          confirmTitle='¿Desea eliminar el registro?'
          confirmText='Confirmar'
          negateText='Volver atras'
          isLoading={isLoadingConfirm}
        />
      </EOSModal>

      <EOSModal
        onClose={handleCloseRedireccion}
        open={openRedireccion}
        maxWidth='sm'
      >
        <ConfirmAction
          handleCloseModal={handleCloseRedireccion}
          handleSubmitAction={handleRedirectZoneCRUD}
          confirmTitle='¿Desea ir al mantenedor de Zonas?'
          confirmText='Confirmar'
          negateText='Volver atras'
        />
      </EOSModal>

      <SnackBar
        open={openSnackbar}
        setOpen={handleSnackbar}
        message={messageStatus}
        status={messageColor}
      />

      <Container maxWidth='xl'>
        <div className={classes.grid}>
          {isLoading && <Loading />}
          {!isLoading && (
            <React.Fragment>
              <WarehouseList
                warehouseList={rows}
                pageSize={rowsPerPage}
                handlePageSize={handlePageSizeChange}
                handleEdit={handleDoubleClick}
                handleDelete={handleOpenDelete}
                handleView={hadleOpenView}
              />
              <Pagination
                page={page + 1}
                totalPages={Math.ceil(totalItems / rowsPerPage)}
                handlePagination={handlePageChange}
              />
            </React.Fragment>
          )}
        </div>
      </Container>
    </Fragment>
  )
}
